export class QuickNoteModel {
    quick_note_code: string
    quick_note_type: string
    quick_note_text: string
    new_code: boolean

    constructor(quick_note_code: string, quick_note_type: string, quick_note_text: string) {
        this.quick_note_code = quick_note_code
        this.quick_note_type = quick_note_type
        this.quick_note_text = quick_note_text
        this.new_code = false
    }
}